/**
 * The option value every "nobody assigned" choice carries: the RAM, DSO manager
 * and DSO name selects, and the people filters. The monolith parses this
 * literal, both as a list filter param and as a PATCH body.
 */
export const UNASSIGNED_OPTION_VALUE = 'unassigned';
